export default __webpack_public_path__ + "media/zurb/img/bryan/pd-3-413df619a151b104807c7396745551fc.png";